import { TextColorType, TextSizeType } from "@/lib/main";
import { CSSProperties, HTMLAttributes } from "react";

type LoadingSpinnerProps = {
  className?: HTMLAttributes<HTMLSpanElement>["className"];
  color?: TextColorType;
  size?: TextSizeType;
};

export default function LoadingSpinner({
  className,
  color,
  size,
}: LoadingSpinnerProps) {
  if (!color) color = "primary";
  if (!size) size = "body-md";

  const styles: CSSProperties = {
    color: `var(--color-text-${color})`,
    display: "inline-block",
    animation: "spin 1s linear infinite",
    fontSize: `var(--font-size-${size})`,
    border: "0.2em solid rgba(0, 0, 0, 0.1)",
    borderTop: `0.2em solid var(--color-text-${color})`,
    borderRadius: "50%",
    height: "1em",
    width: "1em",
  };

  return <span className={className} style={styles}></span>;
}
